import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import './BotPageLayout.css';

/**
 * BotPageLayout – shared header + tab nav for every bot sub-page.
 * Props: botName, botSlug, botColor, botIcon (JSX), botTagline, children
 */
export default function BotPageLayout({ botName, botSlug, botColor = '#add8ff', botIcon, botTagline = '', children }) {
  const tabs = [
    { to: `/${botSlug}/home`,     label: 'Overview'  },
    { to: `/${botSlug}/about`,    label: 'About'     },
    { to: `/${botSlug}/features`, label: 'Features'  },
    { to: `/${botSlug}/invite`,   label: 'Invite'    },
  ];

  return (
    <div className="bot-layout page">
      <div className="bot-layout__header">
        <div className="container bot-layout__header-inner">
          <div className="bot-layout__identity">
            {botIcon && (
              <div className="bot-layout__icon" style={{ background: botColor + '33', color: '#1a2332' }}>
                {botIcon}
              </div>
            )}
            <div>
              <span className="eyebrow">Discord Bot</span>
              <h1 className="bot-layout__name">{botName}</h1>
              {botTagline && <p className="bot-layout__tagline">{botTagline}</p>}
            </div>
          </div>
          <Link to={`/${botSlug}/invite`} className="btn btn--dark">
            Invite Bot
          </Link>
        </div>

        <div className="bot-layout__tabs">
          <div className="container bot-layout__tabs-inner">
            {tabs.map(({ to, label }) => (
              <NavLink key={to} to={to}
                className={({ isActive }) =>
                  `bot-layout__tab${isActive ? ' bot-layout__tab--active' : ''}`
                }
                style={({ isActive }) => isActive ? { borderBottomColor: botColor === '#add8ff' ? 'var(--blue-dark)' : botColor } : {}}
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="bot-layout__content">{children}</div>
    </div>
  );
}